import type { CustomOAuthProvider } from '@/types'
import { oauthCallbackUrl, startOAuth, startCustomOAuth } from './oauth'

/**
 * 绑定第三方账号。
 * new-api v1.0.0 起绑定需要后端签发的安全凭据（scope: account.binding.bind），
 * 由调用方通过 runSecure 传入 securityProof。
 */

interface BindOptions {
  clientId: string
  securityProof?: string
}

/** 绑定用 scope 与上下文：后端把 provider 绑进凭据，凭据不能跨 provider 复用 */
export const OAUTH_BIND_SCOPE = 'account.binding.bind'
export const oauthBindContext = (provider: string) => ({ provider })

export async function bindGitHubOAuth({ clientId, securityProof }: BindOptions): Promise<void> {
  await startOAuth({
    provider: 'github',
    intent: 'bind',
    redirectUri: oauthCallbackUrl('github'),
    securityProof,
    clientId,
  })
}

export async function bindDiscordOAuth({ clientId, securityProof }: BindOptions): Promise<void> {
  await startOAuth({
    provider: 'discord',
    intent: 'bind',
    redirectUri: oauthCallbackUrl('discord'),
    securityProof,
    clientId,
  })
}

export async function bindLinuxDoOAuth({ clientId, securityProof }: BindOptions): Promise<void> {
  await startOAuth({
    provider: 'linuxdo',
    intent: 'bind',
    redirectUri: oauthCallbackUrl('linuxdo'),
    securityProof,
    clientId,
  })
}

export async function bindOidcOAuth(
  authUrl: string,
  { clientId, securityProof }: BindOptions
): Promise<void> {
  await startOAuth({
    provider: 'oidc',
    intent: 'bind',
    redirectUri: oauthCallbackUrl('oidc'),
    securityProof,
    endpoint: authUrl,
    clientId,
  })
}

export async function bindCustomOAuth(
  provider: CustomOAuthProvider,
  securityProof?: string
): Promise<void> {
  await startCustomOAuth(provider, 'bind', securityProof)
}
